import { render, staticRenderFns } from "./dzDown.vue?vue&type=template&id=5b3c6dda&scoped=true&"
import script from "./dzDown.vue?vue&type=script&lang=js&"
export * from "./dzDown.vue?vue&type=script&lang=js&"
import style0 from "./dzDown.vue?vue&type=style&index=0&id=5b3c6dda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3c6dda",
  null
  
)

export default component.exports